module.exports = __webpack_public_path__ + "img/hic-mental-and-behavioural-disorders-female.e461fb7c.png";